'use strict';
import * as _ from 'lodash';
import { module } from '../app';

module
  .factory('FollowUpResolveDialogModel', [
    function () {

      function FollowUpResolveDialogModel(patientAccessToken, clip, followUp, checkIfStillOwningAndNotOffline) {
        let self = this;

        self.originalFollowUp = followUp;
        self.followUp = angular.copy(followUp);
        self.patientAccessToken = patientAccessToken;
        self.clip = clip;
        self.checkIfStillOwningAndNotOffline = checkIfStillOwningAndNotOffline;
        self.loading = false;
        self.resolveDirectiveScope = null;

        self.init = async (modal, scope) => {
          self.modalInstance = modal;
          self._scope = scope;
        };

        self.setResolveDirectiveScope = (directiveScope) => {
          self.resolveDirectiveScope = directiveScope;
        };

        self.saveAndResolve = async () => {
          if (!self.resolveDirectiveScope || !self.resolveDirectiveScope.proceedResolveFollowUp) {
            return;
          }

          angular.extend(self.originalFollowUp, {
            FUReason: self.followUp.FUReason,
            Notes: self.followUp.Notes
          });
          
          self.resolveDirectiveScope.followUp = self.originalFollowUp;
          
          await self.resolveDirectiveScope.proceedResolveFollowUp();
        };

        self.onResolved = () => {
          self._scope.model.isCanceled = false;
          self.modalInstance.remove();
        };

        self.close = async () => {
          self._scope.model.isCanceled = true;
          self.modalInstance.remove();
        };

        self.closeWindow = async () => {
          self._scope.model.isCanceled = true;
          self.modalInstance.remove();
        };
      }

      return FollowUpResolveDialogModel;
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/models/followUpResolveDialogModel.js